// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--LZE0a";
export var footerApps = "Footer-module--footerApps--JUJg7";
export var footerContent = "Footer-module--footerContent--ERCNw";